import type { PollScoreDefinition } from '@/shared/tools/communicationBoardPolls'
import { ThanksFace, ThanksRow, ThanksText } from './styled-components'

type PollThanksProps =
  | { hidden: true }
  | {
      hidden: false
      text: string
      face: PollScoreDefinition
      faceLabel: string
    }

const PollThanks = (props: PollThanksProps) => {
  if (props.hidden) {
    return null
  }

  const { text, face, faceLabel } = props

  return (
    <ThanksRow role='status'>
      <ThanksFace $colorKey={face.colorKey} title={faceLabel}>
        <face.Icon size={20} />
      </ThanksFace>
      <ThanksText>{text}</ThanksText>
    </ThanksRow>
  )
}

export default PollThanks
